import React, {useState, useEffect} from 'react';
import {DialogTitle, MenuItem} from '@material-ui/core';
import {DialogContent} from '@material-ui/core';
import {Formik} from "formik";
import {TextField, Dialog} from "../../styles/config";
import CircularIntegration from "../../widgets/CircularIntergration";
import {createResource} from "../../utils/formik";
import Resource from "../../crud/resource";
import Translate, {getDataFromResponse} from "../../utils/utils";
import Swal from "sweetalert2";
import {Autocomplete} from "@material-ui/lab";

const EmailContact = ({
                          handleCreate = () => {
                          }, resource, handleUpdate, onCloseModal, initialValues
                      }) => {

    const [open, setOpen] = React.useState(false);
    const [languages, setLanguages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setOpen(initialValues.inspection_id !== undefined);
    }, [initialValues]);

    useEffect(() => {
        const languageResource = new Resource('language');
        languageResource.index().then(response => {
            const {data} = getDataFromResponse(response);
            setLanguages(data);
            setIsLoading(false);
        }).catch(({response: {status}}) => {
            setIsLoading(false);
            Swal.fire({
                icon: 'error',
                text: 'Failed loading languages'
            });
        });
    }, []);

    const closeModal = () => {
        setOpen(false);
        setIsLoading(false);
        onCloseModal();
    };

    return (
        <Dialog style={{backgroundColor: 'rgba(43, 32, 43, 0.8)'}} onClose={closeModal}
                aria-labelledby="customized-dialog-title" open={open}>
            <DialogTitle id="customized-dialog-title" onClose={closeModal}>
                <div className="title__user-wrapper">
                    <div className="title__user-action">
                        <CircularIntegration done={!isLoading} load={isLoading}/>
                    </div>
                    <div className="title__user-title">
                        <h3>
                            Email Report
                        </h3>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={initialValues}
                    onSubmit={(payload, methods) => createResource(payload, methods, resource, setIsLoading, handleCreate)}
                >
                    {({
                          values,
                          status,
                          errors,
                          touched,
                          handleChange,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                      }) => (
                        <form onSubmit={handleSubmit} className="kt-form">
                            {status && (
                                <div role="alert" className="alert alert-danger">
                                    <div className="alert-text">{status}</div>
                                </div>
                            )}

                            <TextField
                                margin="dense"
                                variant="outlined"
                                label={<Translate id="TABLE.ID"/>}
                                disabled={true}
                                fullWidth={true}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={initialValues.inspection_id || ''}
                            />

                            <TextField
                                margin="dense"
                                variant="outlined"
                                label={initialValues.type}
                                disabled={true}
                                fullWidth={true}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={initialValues.account_name || ''}
                            />

                            <TextField
                                hidden
                                margin="dense"
                                variant="outlined"
                                disabled={true}
                                fullWidth={true}
                                onBlur={handleBlur}
                                onChange={handleChange}
                                name={initialValues.type === 'grower' ? 'grower_id' : 'buyer_id'}
                                value={initialValues.account_id}
                            />
                            <Autocomplete
                                multiple
                                options={[]}
                                disabled={true}
                                margin="dense"
                                variant="outlined"
                                defaultValue={initialValues.to || []}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="To"
                                        placeholder=""
                                    />
                                )}
                            />

                            <TextField
                                margin="dense"
                                variant="outlined"
                                label={<Translate id="TABLE.DATE"/>}
                                name="date"
                                disabled={true}
                                fullWidth={true}
                                value={initialValues.created_at || ''}
                            />

                            <TextField
                                select
                                margin="dense"
                                variant="outlined"
                                label={<Translate id="PROFILE.FORM.LANGUAGE"/>}
                                fullWidth={true}
                                name="language_id"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.language_id || initialValues.language_id || ''}
                                helpertext={errors?.language_id}
                                error={Boolean(errors?.language_id)}
                            >

                                <MenuItem key='default' value=''>
                                    {<Translate id="TRANSLATOR.SELECT"/>}
                                </MenuItem>
                                {languages.map(language => (
                                    <MenuItem key={language.id} value={language.id}>
                                        {language.name}
                                    </MenuItem>
                                ))}

                            </TextField>

                            <TextField
                                multiline
                                minRows={4}
                                maxRows={6}
                                margin="dense"
                                variant="outlined"
                                type="text"
                                autoComplete="off"
                                label={<Translate id="DIALOG.FORM.CONCERN"/>}
                                fullWidth={true}
                                name="concern"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values?.concern || initialValues.concern || ''}
                                helpertext={touched?.concern && errors?.concern}
                                error={Boolean(touched?.concern && errors?.concern)}
                            />

                            <Autocomplete
                                multiple
                                freeSolo
                                options={[]}
                                margin="dense"
                                variant="outlined"
                                onBlur={handleBlur}
                                onChange={(e, cc) => {
                                   values.cc = Array.isArray(cc) ? cc : [cc];
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="email"
                                        onChange={handleChange}
                                        name="cc"
                                    />
                                )}
                            />

                            <div className="kt-add-user__actions">
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}
                                >
                                    <Translate id="TABLE.ACTIONS.EMAIL"/>
                                </button>
                                <i
                                    onClick={closeModal}
                                    className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                                >
                                    <Translate id="DIALOG.FORM.BUTTON.CLOSE"/>
                                </i>
                            </div>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default EmailContact;
